export default new class NCSThemes
{
    NCSLight = {
        name: 'NCSLight',
        dark: false,
        colors: {
            'alarm-critical': '#bf0d3e',
            'alarm-major': '#e57200',
            'alarm-minor': '#ffb81c',
            'alarm-info': '#2196F3',
            'alarm-none': '#4CAF50',
            'alarm-unknown': '#8cacaf',
            'series-1': '#0694a8',
            'series-2': '#f67c01',
            'series-3': '#019c15',
            'series-4': '#88075f',
            'series-5': '#00306c',
            'series-6': '#fbc02d',
            'series-7': '#39eec0',
            'series-8': '#abd533',
            'series-9': '#85d2e1',
            'series-10': '#6a7f2f',
            'series-11': '#d40001',
            primary: '#003595',
            secondary: '#d7d7d7',
            accent: '#e0e0e0',
            error: '#bf0d3e',
            warning: '#ffb81c',
            info: '#2196F3',
            success: '#4CAF50',
            background: '#efefef',
            contentArea: '#f1f1f2',
            dialogTitle: '#e0e0e0',
            navDrawerBg: '#ffffff',
            navDrawerFg: '#abebcb',
            surface: '#ffffff',
            text: '#000000',
            softText: '#808080',
            hover: '#bfd7e866',
            selected: '#e1d7cd',
            link: '#003595'
        }
    }

    NCSLightAccessible1 = {
        name: 'NCSLightAccessible1',
        dark: false,
        colors: {
            'alarm-critical': '#B63221',
            'alarm-major': '#FF8E3C',
            'alarm-minor': '#F4D465',
            'alarm-info': '#0094FF',
            'alarm-none': '#6034DA',
            'alarm-unknown': '#8cacaf',
            'series-1': '#0094FF',
            'series-2': '#FF8E3C',
            'series-3': '#6034DA',
            'series-4': '#F4D465',
            'series-5': '#B63221',
            'series-6': '#4471EC',
            'series-7': '#D67835',
            'series-8': '#929292',
            'series-9': '#A52919',
            'series-10': '#E7C44B',
            'series-11': '#008AEE',
            primary: '#4471EC',
            secondary: '#929292',
            accent: '#e0e0e0',
            error: '#B63221',
            warning: '#F4D465',
            info: '#0094FF',
            success: '#6034DA',
            background: '#efefef',
            contentArea: '#f1f1f2',
            dialogTitle: '#e0e0e0',
            navDrawerBg: '#ffffff',
            navDrawerFg: '#abebcb',
            surface: '#ffffff',
            text: '#000000',
            softText: '#808080',
            hover: '#bfd7e8',
            selected: '#e1d7cd',
            link: '#4471EC'
        }
    }

    /*** removing for release, will add back after release **
    NCSDark = {
        name: 'NCSDark',
        dark: true,
        colors: {
            'alarm-critical': '#bf0d3e',
            'alarm-major': '#e57200',
            'alarm-minor': '#ffb81c',
            'alarm-info': '#2196F3',
            'alarm-none': '#4CAF50',
            'alarm-unknown': '#8cacaf',
            'series-1': '#0694a8',
            'series-2': '#f67c01',
            'series-3': '#019c15',
            'series-4': '#88075f',
            'series-5': '#00306c',
            'series-6': '#fbc02d',
            'series-7': '#39eec0',
            'series-8': '#abd533',
            'series-9': '#85d2e1',
            'series-10': '#6a7f2f',
            'series-11': '#d40001',
            primary: '#4471EC',
            secondary: '#3d3f4a',
            accent: '#7e7f86',
            error: '#B63221',
            warning: '#F4D465',
            info: '#0094FF',
            success: '#4CAF50',
            background: '#282a36',
            contentArea: '#f1f1f2',
            dialogTitle: '#363948',
            navDrawerBg: '#ffffff',
            navDrawerFg: '#abebcb',
            surface: '#44475a',
            text: '#ffffff',
            softText: '#808080',
            hover: '#bfd7e8',
            selected: '#e1d7cd',
            borderTop: '#3d3f4a',
            borderBottom: '#858585',
            link: '#e1d7cd',
        }
    }
        ***/
}
